import styled from 'styled-components';

export const DueDateContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

export const DueDateInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DueDateText = styled.span`
  font-size: 14px;
  color: #b0b8c0;

  &.completed {
    text-decoration: line-through;
    color: #8c98a4;
  }
`;
